import React from "react";

class FloatModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            setClass: false,
        };
    }

    closeFunc = () => {
        this.setState({ setClass: true });
        setTimeout(() => {
            if (this.props.closeAction) this.props.closeAction();
        }, 500);
    };

    okFunc = () => {
        this.setState({ setClass: true });
        setTimeout(() => {
            if (this.props.okAction) this.props.okAction();
        }, 500);
    };

    render() {
        return (
            <div className="confirmaiton_modal float">
                <div className="confirmaiton_bg" onClick={this.closeFunc}></div>
                <div
                    className={`confirmaiton_window ${
                        this.state.setClass ? "close" : ""
                    }`}
                >
                    {this.props.image ? (
                        <div className="image">{this.props.image}</div>
                    ) : (
                        ""
                    )}

                    {this.props.title ? (
                        <div
                            className={`float_title ${
                                this.props.titleCenter ? "center" : ""
                            }`}
                        >
                            <h3>{this.props.title}</h3>
                        </div>
                    ) : (
                        ""
                    )}

                    <div className="content">
                        {/* Произвольный JSX через children */}
                        {this.props.children}

                        {/* Произвольный JSX через description */}
                        {this.props.description ? (
                            <div className="description">
                                {this.props.description}
                            </div>
                        ) : (
                            ""
                        )}

                        {this.props.iframe ? (
                            <div
                                className="iframe-container"
                                id="iframeContainer"
                            >
                                <iframe
                                    id="contentFrame"
                                    src={this.props.iframe}
                                ></iframe>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>

                    <div className="confirmation_footer">
                        {this.props.okText ? (
                            <button
                                className={"btn btn_tdk"}
                                onClick={this.okFunc}
                            >
                                <span>{this.props.okText}</span>
                            </button>
                        ) : (
                            ""
                        )}
                        {this.props.cancelText ? (
                            <button
                                type="cancel"
                                onClick={this.closeFunc}
                                className={"btn btn_tdk"}
                            >
                                <span>{this.props.cancelText}</span>
                            </button>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default FloatModal;